import { retrieveLaunchParams } from '@telegram-apps/sdk-react'
import animationData from './sticker.json'
import { useMemo } from 'react'
import ErrorScreen from '../ErrorScreen'

console.log(animationData)

export default function OutdatedClientError(props: {
	requiredVersion: string
}) {
	const [maxApiSupport] = useMemo(() => {
		let maxApiSupport
		try {
			maxApiSupport = retrieveLaunchParams().version
		} catch {
			/**/
		}

		return [maxApiSupport]
	}, [])
	return (
		<ErrorScreen
			header="Telegram update required"
			description={`Your Telegram app only supports Bot API features up to ${maxApiSupport}, but Hillary's Empire needs at least ${props.requiredVersion}. Please update Telegram to play.`}
			lottieAnimationData={animationData}
		/>
	)
}
